import React from "react";
import SideMenu from "./../../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../../components/basicComponent/MuiInput";
import { MuiDropDown } from "./../../components/basicComponent/MuiDropDown";
import MuiButton from "./../../components/basicComponent/MuiButton";
import MuiDatePicker from "./../../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "./../../components/basicComponent/MuiSearchSelect";
import Header from "./../../sharedScreens/Header";
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import WalletIcon from '@mui/icons-material/Wallet';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { useGlobalState } from "../../services/context/AuthContext";

const CreditControl = () => {
  const { userInfo } = useGlobalState();
  const currency = userInfo?.currencyCode || "AED";
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Credit Control</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Branch "}
                          label="Branch "
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Business Unit"}
                          label="Business Unit "
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Customer Name"}
                          placeholder="Customer Name"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Payment Mode "}
                          label="Payment Mode  "
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Requested ByAmount "}
                          placeholder="Requested ByAmount "
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput label={"Amount "} placeholder="Amount " />
                      </div>

                      <div className="col-md-4 mt-3">
                        <MuiInput label={"Remarks  "} placeholder="Remarks  " />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton className="clear-btn " label="Clear" />
                          <MuiButton
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                            label={"Get"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="card my-3">
                  <div className="card-header">
                    <h3 className="card-title">Balance Details</h3>
                  </div>
                  <div className="card-body">
                    <div className="grid gap-4">
                      <div className="flex justify-between gap-3">
                        <div className="flex items-center gap-2.5">
                          <div className="flex items-center justify-center size-7.5 shrink-0 bg-gray-100 rounded-lg border border-gray-300">
                            <ReceiptIcon className="text-gray-600"/>
                          </div>
                          <div className="flex flex-col gap-0.5">
                            <span className="text-2sm font-medium text-gray-900 cursor-pointer hover:text-primary mb-px">
                              Last Transaction
                            </span>
                            <span className="text-2xs text-gray-700">
                              05/03/2025 17:04:44
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center gap-2.5">
                          <span className="text-sm text-gray-800">{currency} 10</span>
                        </div>
                      </div>
                      <div className="flex justify-between gap-3">
                        <div className="flex items-center gap-2.5">
                          <div className="flex items-center justify-center size-7.5 shrink-0 bg-gray-100 rounded-lg border border-gray-300">
                           <PaymentIcon className="text-gray-600"/>
                          </div>
                          <div className="flex flex-col gap-0.5">
                            <span className="text-2sm font-medium text-gray-900 cursor-pointer hover:text-primary mb-px">
                              Last Topup Amount
                            </span>
                            <span className="text-2xs text-gray-700">
                              05/03/2025 17:04:44
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center gap-2.5">
                          <span className="text-sm text-gray-800">{currency} 10</span>
                        </div>
                      </div>
                      <div className="flex justify-between gap-3">
                        <div className="flex items-center gap-2.5">
                          <div className="flex items-center justify-center size-7.5 shrink-0 bg-gray-100 rounded-lg border border-gray-300">
                           <WalletIcon className="text-gray-600"/>
                          </div>
                          <div className="flex flex-col gap-0.5">
                            <span className="text-2sm font-medium text-gray-900 cursor-pointer hover:text-primary mb-px">
                              Account Balance
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center gap-2.5">
                          <span className="text-sm text-gray-800">
                            {currency} 8534
                          </span>
                        </div>
                      </div>
                      <div className="flex justify-between gap-3">
                        <div className="flex items-center gap-2.5">
                          <div className="flex items-center justify-center size-7.5 shrink-0 bg-gray-100 rounded-lg border border-gray-300">
                           <CreditScoreIcon className="text-gray-600"/>
                          </div>
                          <div className="flex flex-col gap-0.5">
                            <span className="text-2sm font-medium text-gray-900 cursor-pointer hover:text-primary mb-px">
                              Outstanding Amount
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center gap-2.5">
                          <span className="text-sm text-gray-800">0</span>
                        </div>
                      </div>
                      <div className="flex justify-between gap-3">
                        <div className="flex items-center gap-2.5">
                          <div className="flex items-center justify-center size-7.5 shrink-0 bg-gray-100 rounded-lg border border-gray-300">
                         <AccountBalanceIcon className="text-gray-600"/>
                          </div>
                          <div className="flex flex-col gap-0.5">
                            <span className="text-2sm font-medium text-gray-900 cursor-pointer hover:text-primary mb-px">
                              Accounts Ref ID
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center gap-2.5">
                          <span className="text-sm text-gray-800">N/A </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card my-3">
                  <div className="card-header">
                    <h3 className="card-title">Contact Information</h3>
                  </div>
                  <div className="card-body pt-3.5 pb-3.5">
                    <div className="flex justify-between gap-3">
                      <div className="flex items-center gap-2.5">
                      <i className="fa-solid fa-user"></i>
                        <div className="flex flex-col gap-0.5">
                          <span className="text-2sm font-medium text-gray-900 cursor-pointer hover:text-primary mb-px">
                          Sales Person
                          </span>
                          
                        </div>
                      </div>
                      {/* <div className="flex items-center gap-2.5">
                        <span className="text-sm text-gray-800">{currency} 10</span>
                      </div> */}
                    </div>


                    <div className="flex justify-between gap-3 mt-2">
                      <div className="flex items-center gap-2.5">
                      <i className="fa-solid fa-phone"></i>
                        <div className="flex flex-col gap-0.5">
                          <span className="text-2sm font-medium text-gray-900 cursor-pointer hover:text-primary mb-px">
                          Customer Contact Number
                          </span>
                          
                        </div>
                      </div>
                      {/* <div className="flex items-center gap-2.5">
                        <span className="text-sm text-gray-800">{currency} 10</span>
                      </div> */}
                    </div>

                    <div className="flex justify-between gap-3 mt-2">
                      <div className="flex items-center gap-2.5">
                      <i className="fa-solid fa-envelope"></i>
                        <div className="flex flex-col gap-0.5">
                          <span className="text-2sm font-medium text-gray-900 cursor-pointer hover:text-primary mb-px">
                          Customer Email Id
                          </span>
                          
                        </div>
                      </div>
                      <div className="flex items-center gap-2.5">
                        <span className="text-sm text-gray-800">demo01@gmail.com</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CreditControl;
